// addresses modules
import axios from 'axios';
import {
  ADDRESS_URL,
  DEFAULT_ADDRESS_URL,
  ADDRESS_AUTOCOMPLETE_URL,
  ADDRESS_AUTOCOMPLETE_DETAIL_URL,
  WAREHOUSE_LIST_URL,
} from '../../api/url.js';
import { STATES, CA_STATES } from '../../../config/default';
import request from '../../api/request.js';

// initial state
const state = {
  customerDetails: [],
  billingAddresses: [],
  warehouseAddresses: [],
  
  defaultAddress: {},
  states: STATES,
  ca_states: CA_STATES,
  // successfullyPosted: false,
}

// actions
const actions = {
  // fetchAddresses
  async fetchAddresses(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    await axios(config) 
      .then((response) => {
        context.commit('fetchAddresses', response.data);
      }, (err) => {
        console.log("fetchAddresses error:", err);
      })
  },
  // fetchDefaultAddresses
  async fetchDefaultAddress(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: DEFAULT_ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    await axios(config) 
      .then((response) => {
        context.commit('fetchDefaultAddress', response.data);
      }, (err) => {
        console.log("fetchDefaultAddress error:", err);
      })
  },
  // postAddress
  async postAddress({ commit, dispatch }, address) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: ADDRESS_URL,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
    // .then((response) => {
    //   dispatch('fetchAddresses');
    // }, (err) => {
    //   alert('error happen when create address, please contact us.');
    // })
  },
  // editAddress
  editAddress(context,[address, customerDetail_id]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'put',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
    // .then((response) => {
    //   location.reload();
    // }, (err) => {
    //   alert('error happen when edit address, please contact us.');
    // })
  },
  // deleteAddress
  deleteAddress({ dispatch }, customerDetail_id) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'delete',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    axios(config) 
    .then((response) => {
      dispatch('fetchAddresses');
      // location.reload();
    }, (err) => {
      alert('error happen when delete address, please contact us.');
    })
  },
  async fetchWarehouseAddresses(context) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'get',
      url: WAREHOUSE_LIST_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    await axios(config) 
      .then((response) => {
        context.commit('fetchWarehouseAddresses', response.data);
      }, (err) => {
        console.log("fetchWarehouseAddresses error:", err);
      })
  },
  // deleteCustomerDetail --- actually same as delete address 
  deleteCustomerDetail: (context, id) => request({ url: `${ADDRESS_URL}/${id}`, method: 'delete' }),
};

export function palceSearch(query) {
  return request({
    url: ADDRESS_AUTOCOMPLETE_URL,
    method: 'get',
    params: query
  })
}
export function fetchAddressDetail(query) {
  return request({
    url: ADDRESS_AUTOCOMPLETE_DETAIL_URL,
    method: 'get',
    params: query
  })
}
export function fetchNoneFBAAddress(query) {
  return request({
    url: ADDRESS_URL,
    method: 'get',
    params: query
  })
}
export function deleteCustomerDetail(id) {
  return request({
    url: `${ADDRESS_URL}/${id}`,
    method: 'delete',
  })
}

// mutations
const mutations = {
  fetchAddresses(state, payload) {
    let shipping = payload.Customer_Detail.filter(address => {
      return address.Type === "Shipping";
    });
    let billing = payload.Customer_Detail.filter(address => {
      return address.Type === "Billing";
    });
    state.customerDetails = shipping;
    state.billingAddresses = billing;
    
  },
  fetchWarehouseAddresses(state, payload) {
    state.warehouseAddresses = payload.warehouses;
    
  },
  fetchDefaultAddress(state, payload) {
    state.defaultAddress = payload
  }
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js